import { TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  CheckboxCell as CheckboxCellBase,
  SelectBox as SelectBoxBase,
} from '../../styles';

export const Wrapper = styled(TableRow)`
  &.stickyCollapsed {
    z-index: 99;
    background: transparent;
  }
  &.showInCollapsed {
    z-index: 99;
    background: transparent;
  }
  &.hideInCollapsed {
    z-index: 0;
    background: transparent;
  }
  z-index: 9999;
  background-color: ${(p) =>
    p.theme.palette.mode === 'dark'
      ? p.theme.palette.background.paper
      : p.theme.palette.primary[50]};
  position: relative;

  ::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  &.Clickable {
    cursor: pointer;
  }
`;

export const CheckboxCell = styled(CheckboxCellBase)``;

export const Cell = styled(TableCell)`
  z-index: 10;
  position: relative;
`;

export const SelectBox = styled(SelectBoxBase)`
  /* cursor: not-allowed; */
`;
